
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booktable",
      function () {
        return require("private-next-pages/booktable/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booktable"])
      });
    }
  